import { render, staticRenderFns } from "./threeInOne.vue?vue&type=template&id=208c08c4&scoped=true&"
import script from "./threeInOne.vue?vue&type=script&lang=js&"
export * from "./threeInOne.vue?vue&type=script&lang=js&"
import style0 from "./threeInOne.vue?vue&type=style&index=0&id=208c08c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c08c4",
  null
  
)

export default component.exports